import React from "react";
import hire from "../images/hire.png";
import "./styles.css";
const Hire = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-xs-3" style={{ borderRadius: "50px!important" }}>
          <img
            src={hire}
            alt="Hire"
            style={{ borderRadius: "50%!important" }}
          />
        </div>
        <div className="col-xs-9">
          <div className="ptitle"> Hire Me</div>

          <div className="pbody">
            I am open for full time front end developer position <br></br>
            <a
              className="pbottom"
              href="https://drive.google.com/file/d/159KdLka42pW88qyp1OMEDht3cI8ZIEVI/view?usp=sharing"
            >
              Checkout my Resume
            </a>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Hire;
